module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35"><circle class="cls-1" cx="17.5" cy="17.5" r="17.5" fill="#6d1c83"/><path class="cls-2" d="M11.505 15.009l6.5 6.919 6.5-6.919" fill="none" stroke="#fff"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow.svg
// module id = 514
// module chunks = 1